// extracted by mini-css-extract-plugin
export default {"errorColor":"#d34f6f","activeDefaultColor":"#8f27c7"};